/**
 * Footer.tsx
 * Exact port of Blazor Shared/Components/Footer.razor.
 *
 * Structure (left → right):
 *   Copyright © {year} Deloitte Development LLC. All rights reserved.
 *   Privacy | Cookies | Cookie Settings
 *
 * Styles translated directly from Footer.razor inline <style> block.
 */
export function Footer() {
  const year = new Date().getFullYear()

  const handleCookieSettings = () => {
    // OneTrust cookie consent toggle — matches Blazor class="optanon-toggle-display"
    if (typeof window !== 'undefined' && 'OneTrust' in window) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;(window as any).OneTrust?.ToggleInfoDisplay()
    }
  }

  return (
    <footer
      className="flex w-full shrink-0 items-center justify-between px-[25px]"
      style={{ background: '#f6f6f6', boxShadow: 'inset 0 1px 0 0 #e6e6e6', height: '64px' }}
    >
      {/* Left: copyright */}
      <div className="text-[13px] leading-5 text-[#97999b]">
        Copyright &copy; {year} Deloitte Development LLC. All rights reserved.
      </div>

      {/* Right: legal links */}
      <div className="text-[13px] leading-5 text-[#97999b]">
        <p className="m-0">
          <a
            href="https://www2.deloitte.com/us/en/legal/privacy.html"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0076a8] no-underline hover:underline"
          >
            Privacy
          </a>
          {' | '}
          <a
            href="https://cookienotice.deloitte.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0076a8] no-underline hover:underline"
          >
            Cookies
          </a>
          {' | '}
          <button
            type="button"
            onClick={handleCookieSettings}
            className="cursor-pointer border-0 bg-transparent p-0 text-[13px] text-[#0076a8] leading-5 hover:underline"
          >
            Cookie Settings
          </button>
        </p>
      </div>
    </footer>
  )
}
